import { Action } from 'redux';
import { OrderItems } from 'src/types/model';

export interface OrderItemsState {
  loading: boolean;
  data: OrderItems;
  error: string | null;
}

export const FETCH_ORDER_ITEMS_REQUEST = 'FETCH_ORDER_ITEMS_REQUEST';
export const FETCH_ORDER_ITEMS_SUCCESS = 'FETCH_ORDER_ITEMS_SUCCESS';
export const FETCH_ORDER_ITEMS_FAILURE = 'FETCH_ORDER_ITEMS_FAILURE';
export const SET_ORDER_DATE = 'SET_ORDER_DATE';
export const SET_ORDER_CACHE = 'SET_ORDER_CACHE';
export const SET_ORDER_FILTERS = 'SET_ORDER_FILTERS';
export const SET_ORDER_PAYMENT_TYPE = 'SET_ORDER_PAYMENT_TYPE';
export const TRIGGER_ORDERS_REFETCH = 'TRIGGER_ORDERS_REFETCH';

export interface FetchOrderItemsRequestAction
  extends Action<typeof FETCH_ORDER_ITEMS_REQUEST> {}

export interface FetchOrderItemsSuccessAction
  extends Action<typeof FETCH_ORDER_ITEMS_SUCCESS> {
  payload: OrderItems;
}

export interface FetchOrderItemsFailureAction
  extends Action<typeof FETCH_ORDER_ITEMS_FAILURE> {
  payload: string;
}

export interface SetOrderDateAction
  extends Action<typeof SET_ORDER_DATE> {
    payload: 
    {
      orderStartDate: Date | null,
      orderEndDate: Date | null
    };
}

export interface SetOrderCacheAction
  extends Action<typeof SET_ORDER_CACHE> {
  payload: any;
}

export interface SetOrderPaymentTypeAction
  extends Action<typeof SET_ORDER_PAYMENT_TYPE> {
  payload: any;
}

export interface SetOrderFiltersAction
  extends Action<typeof SET_ORDER_FILTERS> {
  payload: any;
}

export interface TriggerOrdersRefetchAction
  extends Action<typeof TRIGGER_ORDERS_REFETCH> {
    payload: boolean;
  }

export type OrderItemsActionType =
  | FetchOrderItemsRequestAction
  | FetchOrderItemsSuccessAction
  | FetchOrderItemsFailureAction
  | SetOrderDateAction
  | SetOrderCacheAction
  | SetOrderFiltersAction
  | SetOrderPaymentTypeAction
  | TriggerOrdersRefetchAction;